import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React, { forwardRef } from 'react';
import styled from 'styled-components';
var Clickable = /*#__PURE__*/forwardRef(function (/** @type { HTMLAttributes<HTMLButtonElement> } */props, ref) {
  return __jsx(StyledButton, _extends({}, props, {
    ref: ref
  }));
});
export default Clickable;
var StyledButton = styled.button.withConfig({
  displayName: "clickable__StyledButton",
  componentId: "sc-uqcx8d-0"
})(["appearance:none;border:none;padding:0;background-color:transparent;cursor:", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "default" : "pointer";
});